export const REQUEST_DRAW_DOWN_REPAYMENT_SCHEDULE =
    'page/MULTI_FLEXI_LOAN_DRAW_DOWN_REPAYMENT_SCHEDULE [request]';

export const DECLINED_APPLICATION_REAPPLY = 'DECLINED_APPLICATION_REAPPLY';
